export default "__VITE_ASSET__B5W7J3f6__"